export const VERIFY_CREDENTIAL_ID_BEGIN = "VERIFY_CREDENTIAL_ID_BEGIN";
export const VERIFY_CREDENTIAL_ID_SUCCESS = "VERIFY_CREDENTIAL_ID_SUCESS";
export const VERIFY_CREDENTIAL_ID_FAILURE = "VERIFY_CREDENTIAL_ID_FAILURE";

export const UPLOAD_JSON_BEGIN = "UPLOAD_JSON_BEGIN";
export const UPLOAD_JSON_SUCCESS = "UPLOAD_JSON_SUCCESS";
export const UPLOAD_JSON_FAILURE = "UPLOAD_JSON_FAILURE";
